module.exports = __webpack_public_path__ + "static/media/Openid_connect_logo_small.d837e3b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/Openid_connect_logo_small.png
// module id = 64
// module chunks = 0